// src/menu-items/platform.ts
//
// Infrastructure rather than customer data — the machines and services behind
// the platform. One item today; the remaining v3-admintool screens that are not
// rates or numbering belong here as they move over.
import { Server, StatsReport } from 'iconoir-react';

const platform = {
  id: 'platform-group',
  title: 'Platform',
  type: 'group',
  children: [
    {
      id: 'platform-switches',
      title: 'Switches',
      type: 'item',
      url: '/switches',
      icon: Server,
      breadcrumbs: true
    },
    {
      id: 'platform-stats',
      title: 'Monthly / Daily Stats',
      type: 'item',
      url: '/stats',
      icon: StatsReport,
      breadcrumbs: true
    }
  ]
};

export default platform;
